import { CdkScrollable } from '@angular/cdk/scrolling';
import { Component, inject } from '@angular/core';
import { MatButton } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialogRef, MatDialogTitle, MatDialogContent, MatDialogActions } from '@angular/material/dialog';
import { MatDivider } from '@angular/material/divider';
import { MatExpansionPanel, MatExpansionPanelHeader, MatExpansionPanelTitle } from '@angular/material/expansion';
import { MatList, MatListItem } from '@angular/material/list';
import { MatTooltip } from '@angular/material/tooltip';
import { CommonIPStats } from '@model/ftf-api.model';
import { cleanAndTruncateFileName } from '@utils/file-utils';


import { IpIconComponent } from '../../../shared/components/ip-icon/ip-icon.component';


@Component({
  selector: 'app-upload-results-dialog',
  templateUrl: './upload-results-dialog.component.html',
  styleUrls: ['./upload-results-dialog.component.scss'],
  imports: [
    MatDialogTitle,
    CdkScrollable,
    MatDialogContent,
    MatExpansionPanel,
    MatExpansionPanelHeader,
    MatExpansionPanelTitle,
    IpIconComponent,
    MatTooltip,
    MatList,
    MatListItem,
    MatDivider,
    MatDialogActions,
    MatButton
  ],
})
export class UploadResultsDialogComponent {
  dialogRef = inject<MatDialogRef<UploadResultsDialogComponent>>(MatDialogRef);
  data = inject<{
    stats: CommonIPStats[];
}>(MAT_DIALOG_DATA);

  ipStats: CommonIPStats[];
  expanded = true;

  constructor() {
    const { data } = this;

    this.ipStats = data.stats;
  }

  /**
   * Cleans and truncates the file name to the specified length.
   *
   * @param fileName The original file name.
   * @param length The maximum length of the truncated file name.
   * @returns The cleaned and truncated file name.
   */
  cleanAndTruncateFileName(fileName: string, length: number): string {
    return cleanAndTruncateFileName(fileName, length, false, false);
  }
}
